import { gateway } from "../../../../gateway";
import type { IInvoice } from "../../create/interfaces/invoice.interfaces";

export interface IGetInvoicesByJobEventResponse {
  status: number;
  message: string;
  data: IInvoice[];
}

export const getInvoicesByJobEvent = async (jobEventUid: string): Promise<IInvoice[]> => {
  const response = await gateway.get<IGetInvoicesByJobEventResponse>(
    `/invoices/by-job-event/${encodeURIComponent(jobEventUid)}`
  );
  return response.data?.data ?? [];
};
